import { User } from 'firebase/auth';

import { auth } from '@helpers/firebase/Initialize';

type CurrentUser = User & { displayName: string };

export function getAuthenticatedUser(): User {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('Expected an authenticated Firebase user.');
  }
  return currentUser;
}

export function getCurrentUserId(): string {
  return getAuthenticatedUser().uid;
}

export function getCurrentUser(): CurrentUser {
  const currentUser = getAuthenticatedUser();
  if (!currentUser.displayName) {
    throw new Error('Expected an authenticated Firebase user with a display name.');
  }
  return currentUser as CurrentUser;
}
